import { render, staticRenderFns } from "./PolizasIEResponse.vue?vue&type=template&id=13875a5a&scoped=true&"
import script from "./PolizasIEResponse.vue?vue&type=script&lang=js&"
export * from "./PolizasIEResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13875a5a",
  null
  
)

export default component.exports